import React from 'react';
import { useNavigate } from 'react-router-dom';
import ImageUploadField from '../../components/ImageUploadField';
import { BannersIcon } from '../../dashboard/components/product_item_components/icons';
import BusinessColorField from './BusinessColorField';
import BusinessViewField from './BusinessViewField';
import BusinessTypeField from './BusinessTypeField';
import PublicStoreLinkButton from './PublicStoreLinkButton';

function BusinessBannersButton() {
    const navigate = useNavigate();

    return (
        <section className="shop-create-section">
            <div className="shop-create-label">Баннеры</div>
            <div className="shop-create-help">Изображения вверху витрины</div>
            <button
                type="button"
                className="shop-banners-button"
                onClick={() => navigate('/banners')}
            >
                <BannersIcon className="shop-banners-icon" />
                <span>Открыть</span>
            </button>
        </section>
    );
}

export default function BusinessDetailsForm({
    name,
    onNameChange,
    customName,
    onCustomNameChange,
    logoUrl,
    onLogoUrlChange,
    onLogoUploadLoadingChange,
    colorType,
    onColorTypeChange,
    viewType,
    onViewTypeChange,
    typeId,
    onTypeIdChange,
    linkLoading,
}) {
    return (
        <div className="shop-form-split">
            <div className="shop-form-split-col">
                <section className="shop-create-section">
                    <label className="shop-create-label" htmlFor="shop-name">
                        Название <b style={{ color: 'red' }}>*</b>
                    </label>
                    <input
                        id="shop-name"
                        className="shop-create-input"
                        placeholder="например, Макаронная"
                        value={name}
                        onChange={(e) => onNameChange(e.target.value)}
                        autoComplete="off"
                    />
                </section>

                <section className="shop-create-section">
                    <label className="shop-create-label" htmlFor="shop-custom">
                        Логин <b style={{ color: 'red' }}>*</b>
                    </label>
                    <div className="shop-create-help">
                        На английском, без пробелов
                    </div>
                    <PublicStoreLinkButton customName={customName} loading={linkLoading} />
                    <input
                        id="shop-custom"
                        className="shop-create-input"
                        placeholder="например, macaronnaya"
                        value={customName}
                        onChange={(e) => onCustomNameChange(e.target.value)}
                        autoComplete="off"
                    />
                </section>

                <ImageUploadField
                    label="Логотип"
                    help="Выберите изображение — ссылка подставится автоматически"
                    value={logoUrl}
                    onChange={onLogoUrlChange}
                    onUploadLoadingChange={onLogoUploadLoadingChange}
                />
            </div>

            <div className="shop-form-split-col">
                <BusinessBannersButton />

                <BusinessColorField
                    colorType={colorType}
                    onColorTypeChange={onColorTypeChange}
                />

                <BusinessViewField
                    viewType={viewType}
                    onViewTypeChange={onViewTypeChange}
                />

                <BusinessTypeField
                    typeId={typeId}
                    onTypeIdChange={onTypeIdChange}
                />
            </div>
        </div>
    );
}

